var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999997 0.0498047H13C13.4142 0.0498047 13.75 0.385595 13.75 0.799802V12.7998C13.75 13.214 13.4142 13.5498 13 13.5498H0.999997C0.585781 13.5498 0.25 13.214 0.25 12.7998V0.799802C0.25 0.385595 0.585781 0.0498047 0.999997 0.0498047ZM1.74999 1.54981V12.0498H12.25V1.54981H1.74999ZM3.625 4.5498C3.00368 4.5498 2.5 4.04613 2.5 3.4248C2.5 2.80348 3.00368 2.2998 3.625 2.2998C4.24632 2.2998 4.75 2.80348 4.75 3.4248C4.75 4.04613 4.24632 4.5498 3.625 4.5498ZM2.87499 5.2998H4.375V10.9248H2.87499V5.2998ZM7.00002 5.62193C7.43832 5.19881 7.94916 4.92481 8.50005 4.92481C10.0533 4.92481 11.125 6.18398 11.125 7.73733V10.9248H9.62505V7.73733C9.62505 7.01238 9.03735 6.4248 8.31249 6.4248C7.58763 6.4248 7.00002 7.01238 7.00002 7.73733V10.9248H5.50001V5.2998H7.00002V5.62193Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin1);
export default __webpack_public_path__ + "static/media/linkedin1.0021f3210a04b5f3a385de656d221dc7.svg";
export { ForwardRef as ReactComponent };